import React, {Component} from "react";
import database from "./database";
import ListGroup from "reactstrap/es/ListGroup";
import ListGroupItem from "reactstrap/es/ListGroupItem";
import Row from "reactstrap/es/Row";
import Col from "reactstrap/es/Col";
import "./tsd.css";
import Modal from "reactstrap/es/Modal";
import ModalHeader from "reactstrap/es/ModalHeader";
import ModalBody from "reactstrap/es/ModalBody";
import Button from "reactstrap/es/Button";
import Input from "reactstrap/es/Input";
import InputGroupText from "reactstrap/es/InputGroupText";
import Alert from "reactstrap/es/Alert";
import rest from "./restService";
import Spinner from "reactstrap/es/Spinner";
import db from "./database";
import {BiEditAlt} from "react-icons/bi";

class ListGoods extends Component {

    constructor(props) {
        super(props);
        this.state = {
            goodsArray: [],
            isOpen: false,
            isOpenMenu: false,
            item: {},
            alertColor: 'info',
            alertVisible: false,
            alertText: 'info',
            checkPrice: false,
            menuQty: false,
            spinnerClass: 'off',
            percentLoaded: 0,
            isLoad: false,
            qtyFirst: false,
            logText: "",
            isOpenPrice: false
        };

        this.db = new database();
        this.rest = new rest();
        this.menuQty = false;
        this.debug = false;
        this.isSave = false;
        this.newName();
    }

    componentDidMount() {
        this.searchInput.focus();
        let tempArray = JSON.parse(localStorage.getItem('goodsArray'));
        if (!tempArray)
            tempArray = [];
        if (tempArray.length > 0)
            this.setState({
                goodsArray: tempArray
            });
        this.db.loadLocalStorage();
        // this.update();
    }

    spinner(show) {
        if (show && this.searchInput) this.searchInput.disabled = true;
        else this.searchInput.disabled = false;

        let cl = show ? 'spinner' : 'spinner off';
        if (show) this.setState({
            spinnerClass: cl
        });
        this.setState({
            isLoad: show
        });
    }

    update() {
        this.spinner(true);
        (new db(() => {
            this.spinner(false);
            this.db.saveLocalStorage();
        }, (percent) => {
            this.setState({
                percentLoaded: percent
            });
        })).loadAll(true);
        try {
            this.qtyInput.focus();
        } catch {
        }
    }

    newName() {
        this.rest.getNewName((f) => {
            this.docName = f;
        }, (e) => {
            this.docName = 'товары.csv'
        });

    }

    clearSelected() {
        let tempArray = this.state.goodsArray;
        for (let i = 0; i < tempArray.length; i++) {
            tempArray[i].default = false;
        }
    }

    submit(e) {
//        if ((e.key === 'Enter') || (e.target.value.length === 13)) {
        //if (e.key === 'Enter') {
        this.db.newSearch(e.target.value, (res) => {
                this.clearSelected();
                let json_res = JSON.stringify(res);
                let newItem;
                if (res !== -1) {
                    newItem = JSON.parse(json_res);
                    newItem.default = true;
                } else {
                    newItem = {
                        short_name: 'не знайдено',
                        qty: 1,
                        price_out: '0.00',
                        barcode: e.target.value,
                        default: true
                    };
                }
                if (!this.state.goodsArray)
                    this.state.goodsArray = [];
                this.state.goodsArray.unshift(newItem);
                this.setState(this.state);
                if (this.checkPrice) {
                    this.setState({
                        defName: newItem.short_name,
                        defPrice: newItem.price_out,
                        isOpenPrice: true
                    });
                } else if (this.state.menuQty)
                    this.editClicked(null, {
                        item: newItem
                    });
                this.saveGoodsArray();
            }
        );
        e.target.value = '';
        //}
    }

    listClicked(e, item) {
        this.clearSelected();
        item.item.default = true;
        this.setState(this.props);
        this.searchInput.focus();
    }

    editClicked(e, item) {
        this.clearSelected();
        item.item.default = true;
        this.setState({
            isOpen: !this.state.isOpen,
            item: item.item,
            qty: parseInt(item.item.qty, 0),
            qtyFirst: true
        });
        if (this.qtyInput)
            this.qtyInput.focus();
    }

    closeModal() {
        this.setState({
            isOpen: !this.state.isOpen
        });
        this.searchInput.focus();
    }

    clickModalOk() {
        let tempItem = this.state.item;
        tempItem = this.state.item;
        tempItem.qty = this.state.qty;
        this.setState({
            isOpen: !this.state.isOpen,
        });
        this.searchInput.focus();
        this.saveGoodsArray();
    }

    clickBtnQty(type) {
        let mQty = type ? this.state.qty + 1 : this.state.qty - 1;
        if (mQty < 0) {
            mQty = 1;
            return;
        }
        this.qtyInput.value = (mQty).toString();
        this.setState({
            qty: mQty
        });
    }

    qtyInputOnChange(e) {
        this.setState({
            qty: e.target.value,
            qtyFirst: false
        });

        if (typeof e.target.value === 'string') {
            let qtyStr = e.target.value;
            this.setState({
                qty: isNaN(parseInt(qtyStr)) ? 0 : parseInt(qtyStr)
            });
        }
    }

    saveGoodsArray() {
        localStorage.setItem('goodsArray', JSON.stringify(this.state.goodsArray));
    }

    toggleMenu() {
        this.setState({
            isOpenMenu: !this.state.isOpenMenu,
            alertVisible: false
        });
        if (this.searchInput)
            this.searchInput.focus();
    }

    clickNumber(e, num) {
        let qtyText = this.state.qty.toString();
        if (this.state.qtyFirst) {
            this.setState({qtyFirst: false});
            qtyText = '';
        }
        if (num === '#') {
            if (qtyText.length > 1)
                qtyText = qtyText.substring(0, qtyText.length - 1)
            else if (qtyText.length === 1)
                qtyText = '';
        } else {
            qtyText += num;
        }
        let qtyInt = (qtyText === '') ? 0 : parseInt(qtyText, 0);
        this.qtyInput.value = qtyInt;
        this.setState({
            qty: qtyInt
        });
    }

    qtyKeyDown(e) {
        if (this.state.qtyInput) {
            this.setState({qtyFirst: false});
        }
        if (e.key === 'Enter') {
            this.clickModalOk();
        }
    }

    menuChange(type, e) {
        if (type === 'qty')
            this.setState({
                menuQty: e.target.checked
            })
    }

    alertDismiss() {
        this.setState({
            alertVisible: false
        });
    }

    showAlert(color, text) {
        this.setState({
            alertColor: color,
            alertText: text,
            alertVisible: true
        })
    }

    saveDoc() {
        let doc = [];
        if (this.isSave)
            return;
        this.isSave = true;
        this.state.goodsArray.map((item) => {
            doc.unshift(item);
        });
        this.rest.saveDoc(doc, this.docName, (res) => {
            this.isSave = false;
            if (res !== '"ok"') {
                this.showAlert('danger', 'Помилка збереження!');
            } else {
                this.showAlert('success', 'Успішно збережено.');
                this.setState({
                    goodsArray: []
                });
                this.saveGoodsArray();
                this.newName();
            }
        }, (e) => {
            this.isSave = false;
            this.showAlert('danger', 'Помилка збереження!');
        });
    }

    qtyModalOpened() {
        this.qtyInput.focus();
        this.qtyInput.select();

    }

    deleteLine(Line) {
        this.clearSelected();
        let i = this.state.goodsArray.indexOf(this.state.item);
        this.state.goodsArray.splice(i, 1);
        this.setState({
            isOpen: !this.state.isOpen,
        });
        this.searchInput.focus();
        this.saveGoodsArray();
    }

    sendLog(text) {
        if (this.debug)
            this.setState({
                logText: text + this.state.logText
            });
    }

    render() {
        return (
            <div className="body">
                <Spinner color="primary"
                         className="off"/>
                <div className="fixed-top bg-secondary p-3 d-flex justify-content-between align-items-center">
                    <input
                        type="text"
                        className="form-control"
                        ref={(input) => {
                            this.searchInput = input;
                        }}
                        // onKeyDown={(e) => this.submit(e)}
                        onKeyPress={(e) => {
                            //console.log(e.charCode);
                            this.sendLog("k1" + e.charCode)
                            if (e.charCode === 13) {
                                this.sendLog("if ok")
                                this.submit(e);
                            }
                            this.sendLog("ex")
                        }}
                    />
                    <button className="form-control col-3" onClick={() => this.toggleMenu()}>Меню</button>
                </div>
                <ListGroup className="list-group list-goods">
                    {this.state.goodsArray.map((item, index) => {
                        return <ListGroupItem action
                                              active={item.default}
                                              id={index}
                                              key={index}
                                              onClick={(e) => {
                                                  this.listClicked(e, {item})
                                              }}
                        >
                            <Row id={index} className="goods-row">
                                <Row>
                                    <Col xs="12">
                                        {item.short_name}
                                    </Col>
                                </Row>
                                <Row>
                                    <Col className="colName" xs="5">
                                        {item.barcode}
                                    </Col>
                                    <Col xs="2">
                                        {item.qty}
                                    </Col>
                                    <Col xs="3">
                                        {item.price_out}
                                    </Col>
                                    <Col xs="1" className="colButton" onClick={(e) => this.editClicked(e, {item})}>
                                        <BiEditAlt/>
                                    </Col>
                                </Row>
                            </Row>
                        </ListGroupItem>
                    })}
                </ListGroup>
                <Modal isOpen={this.state.isOpen} onOpened={() => this.qtyModalOpened()}>
                    <ModalBody>
                        <div className="row item-row">
                            <div className="col-8 item-text">{this.state.item.short_name}</div>
                            <div className="col-4 item-price">{this.state.item.price_out}</div>
                        </div>
                        <div className="row counter">
                            <div className="col-3 counter-cols">
                                <Button outline color="success" className="i-button" onClick={() => {
                                    this.clickBtnQty(false)
                                }}>&nbsp;-&nbsp;</Button>
                            </div>
                            <div className="col-4 counter-cols">

                                <input
                                    ref={(input) => {
                                        this.qtyInput = input;
                                        if (input)
                                            input.focus();
                                    }}
                                    className="form-control qty-input"
                                    defaultValue={this.state.qty}
                                    onChange={(e) => this.qtyInputOnChange(e)}
                                    onKeyDown={(e) => this.qtyKeyDown(e)}
                                />
                            </div>
                            <div className="col-3 counter-cols">
                                <Button outline color="success" className="i-button" onClick={() => {
                                    this.clickBtnQty(true)
                                }}>+</Button>
                            </div>
                        </div>

                        <div className="keypad">
                            <div className="row">
                                <Button outline color="success" className="i-button"
                                        onClick={(e) => this.clickNumber(e, '1')}>1</Button>
                                <Button outline color="success" className="i-button"
                                        onClick={(e) => this.clickNumber(e, '2')}>2</Button>
                                <Button outline color="success" className="i-button"
                                        onClick={(e) => this.clickNumber(e, '3')}>3</Button>
                            </div>
                            <div className="row">
                                <Button outline color="success" className="i-button"
                                        onClick={(e) => this.clickNumber(e, '4')}>4</Button>
                                <Button outline color="success" className="i-button"
                                        onClick={(e) => this.clickNumber(e, '5')}>5</Button>
                                <Button outline color="success" className="i-button"
                                        onClick={(e) => this.clickNumber(e, '6')}>6</Button>
                            </div>
                            <div className="row">
                                <Button outline color="success" className="i-button"
                                        onClick={(e) => this.clickNumber(e, '7')}>7</Button>
                                <Button outline color="success" className="i-button"
                                        onClick={(e) => this.clickNumber(e, '8')}>8</Button>
                                <Button outline color="success" className="i-button"
                                        onClick={(e) => this.clickNumber(e, '9')}>9</Button>
                            </div>
                            <div className="row">
                                <Button outline color="success" className="i-button invisible-button">0</Button>
                                <Button outline color="success" className="i-button"
                                        onClick={(e) => this.clickNumber(e, '0')}>0</Button>
                                <Button outline color="secondary" className="i-button"
                                        onClick={(e) => this.clickNumber(e, '#')}>{'<'}</Button>
                            </div>
                        </div>
                        <div className="row">
                            <Button color="success" onClick={() => this.clickModalOk()}>Ok</Button>
                            &nbsp;&nbsp;&nbsp;
                            <Button color="primary" onClick={() => this.closeModal()}>Відмінитти</Button>
                            &nbsp;&nbsp;&nbsp;
                            <Button color="danger" onClick={() => this.deleteLine(this.state.item)}>Видалити</Button>
                        </div>
                    </ModalBody>
                </Modal>

                <Modal isOpen={this.state.isOpenMenu}>
                    <ModalHeader toggle={() => this.toggleMenu()}>Меню</ModalHeader>
                    <ModalBody>
                        <InputGroupText>
                            <Input addon type="checkbox"
                                   checked={this.state.menuQty}
                                   onChange={(e) => this.menuChange('qty', e)}
                            />
                            &nbsp;Кількість
                        </InputGroupText>
                        <br/>
                        <Alert className="alert"
                               color={this.state.alertColor}
                               isOpen={this.state.alertVisible}
                               toggle={() => this.alertDismiss()}>
                            {this.state.alertText}
                        </Alert>
                        <div className="row">
                            <div className="col">
                                <Button color="success" onClick={() => {
                                    this.saveDoc()
                                    this.checkPrice = false;
                                }}>Зберегти</Button>
                            </div>
                            <div className="col">
                                <Button color="primary" onClick={() => {
                                    this.toggleMenu();
                                    this.update();
                                }}>Оновити</Button>
                            </div>
                            {/*<div className="col">
                                <Button color="secondary" onClick={(e) => {
                                    this.checkPrice = true;
                                    this.toggleMenu();
                                }}>Перевірка цін</Button>
                            </div>*/}
                        </div>
                        <div>
                            v 3.6
                        </div>
                    </ModalBody>
                </Modal>
                <Modal isOpen={this.state.isLoad}>
                    <ModalBody>
                        <p>Завантаження бази ...</p>
                    </ModalBody>
                </Modal>
                {/*<div className="bottom-line">*/}
                {/*{this.state.logText}*/}
                {/*</div>*/}
            </div>
        )
    }
}

export default function () {
    return (
        <ListGoods></ListGoods>
    )
}
